"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var string_builder_1 = require("./string-builder");
var DateExt = (function () {
    function DateExt() {
    }
    DateExt.reset = function () {
        delete DateExt._formats;
        delete DateExt._parsedRegExp;
    };
    DateExt._appendPreOrPostMatch = function (preMatch, strBuilder) {
        var quoteCount = 0;
        var escaped = false;
        for (var i = 0, il = preMatch.length; i < il; i++) {
            var c = preMatch.charAt(i);
            switch (c) {
                case '\'':
                    if (escaped)
                        strBuilder.append("'");
                    else
                        quoteCount++;
                    escaped = false;
                    break;
                case '\\':
                    if (escaped)
                        strBuilder.append("\\");
                    escaped = !escaped;
                    break;
                default:
                    strBuilder.append(c);
                    escaped = false;
                    break;
            }
        }
        return quoteCount;
    };
    DateExt._expandFormat = function (culture, format) {
        if (!format) {
            format = "F";
        }
        var len = format.length;
        if (len === 1) {
            switch (format) {
                case "d":
                    return culture.dateFormats.short;
                case "D":
                    return culture.dateFormats.long;
                case "t":
                    return culture.timeFormats.short;
                case "T":
                    return culture.timeFormats.long;
                case "f":
                    return culture.dateTimeFormats.short;
                case "F":
                    return culture.dateTimeFormats.long;
            }
        }
        else if ((len === 2) && (format.charAt(0) === "%")) {
            format = format.charAt(1);
        }
        return format;
    };
    DateExt._expandYear = function (year) {
        var TWO_DIGIT_YEAR_MAX = 30;
        var now = new Date(), era = DateExt._getEra(now);
        if (year < 100) {
            var curr = now.getFullYear();
            if (year > TWO_DIGIT_YEAR_MAX) {
                year -= 100;
            }
            year += curr - (curr % 100);
        }
        return year;
    };
    DateExt._getEra = function (date, eras) {
        if (!eras)
            return 0;
        var start, ticks = date.getTime();
        for (var i = 0, l = eras.length; i < l; i += 4) {
            start = eras[i + 2];
            if ((start === null) || (ticks >= start)) {
                return i;
            }
        }
        return 0;
    };
    DateExt._getParseRegExp = function (culture, format) {
        if (!DateExt._parsedRegExp) {
            DateExt._parsedRegExp = {};
        }
        else if (DateExt._parsedRegExp[format]) {
            return DateExt._parsedRegExp[format];
        }
        format = DateExt._expandFormat(culture, format);
        format = format.replace(/([\^\$\.\*\+\?\|\[\]\(\)\{\}])/g, "\\\\$1");
        var regexp = new string_builder_1.StringBuilder("^");
        var groups = [];
        var index = 0;
        var quoteCount = 0;
        var tokenRegExp = DateExt._getTokenRegExp();
        var match;
        while ((match = tokenRegExp.exec(format)) !== null) {
            var preMatch = format.slice(index, match.index);
            index = tokenRegExp.lastIndex;
            quoteCount += DateExt._appendPreOrPostMatch(preMatch, regexp);
            if ((quoteCount % 2) === 1) {
                regexp.append(match[0]);
                continue;
            }
            switch (match[0]) {
                case 'dddd':
                case 'ddd':
                case 'MMMM':
                case 'MMM':
                case 'LLLL':
                case 'LLL':
                case 'EEE':
                case 'EEEE':
                case 'EEEEE':
                case 'EEEEEE':
                case 'ccc':
                case 'cccc':
                case 'ccccc':
                case 'cccccc':
                case 'gg':
                case 'g':
                case 'GG':
                case 'G':
                    regexp.append("(\\D+)");
                    break;
                case 'a':
                    regexp.append("(\\D*)");
                    break;
                case 'yyyy':
                case 'yy':
                case 'y':
                    regexp.append("(\\d+)");
                    break;
                case 'fff':
                    regexp.append("(\\d{3})");
                    break;
                case 'ff':
                    regexp.append("(\\d{2})");
                    break;
                case 'f':
                    regexp.append("(\\d)");
                    break;
                case 'dd':
                case 'd':
                case 'MM':
                case 'M':
                case 'LL':
                case 'L':
                case 'HH':
                case 'H':
                case 'hh':
                case 'h':
                case 'mm':
                case 'm':
                case 'ss':
                case 's':
                    regexp.append("(\\d\\d?)");
                    break;
                case 'zzz':
                case 'zzzz':
                    regexp.append("([+-]?\\d\\d?:\\d{2})");
                    break;
                case 'zz':
                case 'z':
                    regexp.append("([+-]?\\d\\d?)");
                    break;
                default:
                    throw 'Unhandled match pattern ' + match[0];
            }
            groups.push(match[0]);
        }
        DateExt._appendPreOrPostMatch(format.slice(index), regexp);
        regexp.append("$");
        var regexpStr = regexp.toString().replace(/\s+/g, "\\s+");
        var parseRegExp = { 'regExp': regexpStr, 'groups': groups };
        DateExt._parsedRegExp[format] = parseRegExp;
        return parseRegExp;
    };
    DateExt._getTokenRegExp = function () {
        return /G{1,2}|y{4}|y{1,2}|M{1,5}|L{1,5}|d{1,2}|E{3,6}|e{1,6}|c{1,6}|a|h{1,2}|H{1,2}|m{1,2}|s{1,2}|z{1,4}/g;
    };
    DateExt._getLocaleFormats = function (culture) {
        if (DateExt._formats)
            return DateExt._formats;
        DateExt._formats = [];
        var add = function (formats) {
            for (var key in formats) {
                var format = formats[key];
                if (DateExt._formats.indexOf(format) < 0)
                    DateExt._formats.push(format);
            }
        };
        add(culture.dateTimeFormats);
        add(culture.dateFormats);
        add(culture.timeFormats);
        return DateExt._formats;
    };
    DateExt.parse = function (culture, value, formats) {
        var custom = false;
        var i, l;
        if (formats) {
            for (i = 0, l = formats.length; i < l; i++) {
                var format = formats[i];
                if (format) {
                    custom = true;
                    var date = DateExt._parseExact(culture, value, format);
                    if (date)
                        return date;
                }
            }
        }
        if (!custom) {
            formats = DateExt._getLocaleFormats(culture);
            for (i = 0, l = formats.length; i < l; i++) {
                var date = DateExt._parseExact(culture, value, formats[i]);
                if (date)
                    return date;
            }
        }
        return null;
    };
    DateExt._parseExact = function (culture, value, format) {
        value = value.trim();
        var parseInfo = DateExt._getParseRegExp(culture, format), match = new RegExp(parseInfo.regExp).exec(value);
        if (match === null)
            return null;
        var groups = parseInfo.groups, era = null, year = null, month = null, date = null, weekDay = null, hour = 0, hourOffset, min = 0, sec = 0, msec = 0, tzMinOffset = null, pmHour = false;
        for (var j = 0, jl = groups.length; j < jl; j++) {
            var matchGroup = match[j + 1];
            if (matchGroup) {
                switch (groups[j]) {
                    case 'dd':
                    case 'd':
                        date = parseInt(matchGroup, 10);
                        if ((date < 1) || (date > 31))
                            return null;
                        break;
                    case 'eee':
                    case 'EEE':
                        weekDay = culture.day.format.abbreviated.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'eeee':
                    case 'EEEE':
                        weekDay = culture.day.format.wide.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'eeeee':
                    case 'EEEEE':
                        weekDay = culture.day.format.narrow.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'eeeeee':
                    case 'EEEEEE':
                        weekDay = culture.day.format.short.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'ccc':
                        weekDay = culture.day.standAlone.abbreviated.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'cccc':
                        weekDay = culture.day.standAlone.wide.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'ccccc':
                        weekDay = culture.day.standAlone.narrow.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'cccccc':
                        weekDay = culture.day.standAlone.short.indexOf(matchGroup);
                        if ((weekDay < 0) || (weekDay > 6))
                            return null;
                        break;
                    case 'M':
                    case 'MM':
                    case 'L':
                    case 'LL':
                        month = parseInt(matchGroup, 10) - 1;
                        if ((month < 0) || (month > 11))
                            return null;
                        break;
                    case "MMM":
                        month = culture.month.format.abbreviated.indexOf(matchGroup);
                        if ((month < 0) || (month > 11))
                            return null;
                        break;
                    case "MMMM":
                        month = culture.month.format.wide.indexOf(matchGroup);
                        if ((month < 0) || (month > 11))
                            return null;
                        break;
                    case "MMMMM":
                        month = culture.month.format.narrow.indexOf(matchGroup);
                        if ((month < 0) || (month > 11))
                            return null;
                        break;
                    case "LLL":
                        month = culture.month.standAlone.abbreviated.indexOf(matchGroup);
                        if ((month < 0) || (month > 11))
                            return null;
                        break;
                    case "LLLL":
                        month = culture.month.standAlone.wide.indexOf(matchGroup);
                        if ((month < 0) || (month > 11))
                            return null;
                        break;
                    case "LLLLL":
                        month = culture.month.standAlone.narrow.indexOf(matchGroup);
                        if ((month < 0) || (month > 11))
                            return null;
                        break;
                    case 'y':
                    case 'yy':
                        year = DateExt._expandYear(parseInt(matchGroup, 10));
                        if ((year < 0) || (year > 9999))
                            return null;
                        break;
                    case 'yyyy':
                        year = parseInt(matchGroup, 10);
                        if ((year < 0) || (year > 9999))
                            return null;
                        break;
                    case 'h':
                    case 'hh':
                        hour = parseInt(matchGroup, 10);
                        if (hour === 12)
                            hour = 0;
                        if ((hour < 0) || (hour > 11))
                            return null;
                        break;
                    case 'H':
                    case 'HH':
                        hour = parseInt(matchGroup, 10);
                        if ((hour < 0) || (hour > 23))
                            return null;
                        break;
                    case 'm':
                    case 'mm':
                        min = parseInt(matchGroup, 10);
                        if ((min < 0) || (min > 59))
                            return null;
                        break;
                    case 's':
                    case 'ss':
                        sec = parseInt(matchGroup, 10);
                        if ((sec < 0) || (sec > 59))
                            return null;
                        break;
                    case 'a':
                        var upperToken = matchGroup.toUpperCase();
                        pmHour = (upperToken === culture.pm.toUpperCase());
                        if (!pmHour && (upperToken !== culture.am.toUpperCase()))
                            return null;
                        break;
                    case 'zzz':
                    case 'zzzz':
                        var offsets = matchGroup.split(/:/);
                        if (offsets.length !== 2)
                            return null;
                        hourOffset = parseInt(offsets[0], 10);
                        if ((hourOffset < -12) || (hourOffset > 13))
                            return null;
                        var minOffset = parseInt(offsets[1], 10);
                        if ((minOffset < 0) || (minOffset > 59))
                            return null;
                        tzMinOffset = (hourOffset * 60) + (matchGroup.indexOf('-') == 0 ? -minOffset : minOffset);
                        break;
                    case 'z':
                    case 'zz':
                        hourOffset = parseInt(matchGroup, 10);
                        if ((hourOffset < -12) || (hourOffset > 13))
                            return null;
                        tzMinOffset = hourOffset * 60;
                        break;
                    case 'g':
                    case 'gg':
                    case 'GG':
                    case 'G':
                        var eraName = matchGroup;
                        if (!eraName || !DateExt.era)
                            return null;
                        eraName = eraName.toLowerCase().trim();
                        for (var i = 0, l = DateExt.era.length; i < l; i += 4) {
                            if (eraName === DateExt.era[i + 1].toLowerCase()) {
                                era = i;
                                break;
                            }
                        }
                        if (era === null)
                            return null;
                        break;
                }
            }
        }
        var result = new Date(), defaultYear, convert = culture.convert;
        var isUniversal = format === culture.dateFormats.universal ||
            format === culture.dateTimeFormats.universal;
        if (!isUniversal && convert) {
            defaultYear = convert.fromGregorian(result)[0];
        }
        else {
            defaultYear = result.getFullYear();
        }
        if (year === null) {
            year = defaultYear;
        }
        else if (DateExt.era) {
            year += DateExt.era[(era || 0) + 3];
        }
        if (month === null) {
            month = result.getMonth();
        }
        if (date === null) {
            date = result.getDate();
        }
        if (!isUniversal && convert) {
            result = convert.toGregorian(year, month, date);
            if (result === null)
                return null;
        }
        else {
            result.setFullYear(year, month, date);
            if (result.getDate() !== date)
                return null;
            if ((weekDay !== null) && (result.getDay() !== weekDay)) {
                return null;
            }
        }
        if (pmHour && (hour < 12)) {
            hour += 12;
        }
        result.setHours(hour, min, sec, msec);
        if (tzMinOffset !== null) {
            var adjustedMin = result.getMinutes() - (tzMinOffset + result.getTimezoneOffset());
            result.setMinutes(adjustedMin);
        }
        return result;
    };
    DateExt._getWeekDay = function (days, date) {
        return days[date.getDay()];
    };
    DateExt.toFormattedString = function (culture, date, format) {
        format = DateExt._expandFormat(culture, format);
        var ret = new string_builder_1.StringBuilder();
        var hour;
        var addLeadingZero = function (num) {
            if (num < 10) {
                return '0' + num;
            }
            return num.toString();
        };
        var addLeadingZeros = function (num) {
            if (num < 10) {
                return '00' + num;
            }
            if (num < 100) {
                return '0' + num;
            }
            return num.toString();
        };
        var padYear = function (year) {
            if (year < 10) {
                return '000' + year;
            }
            else if (year < 100) {
                return '00' + year;
            }
            else if (year < 1000) {
                return '0' + year;
            }
            return year.toString();
        };
        var foundDay, checkedDay, dayPartRegExp = /([^d]|^)(d|dd)([^d]|$)/g;
        function hasDay() {
            if (foundDay || checkedDay) {
                return foundDay;
            }
            foundDay = dayPartRegExp.test(format);
            checkedDay = true;
            return foundDay;
        }
        var quoteCount = 0, tokenRegExp = DateExt._getTokenRegExp(), converted = [];
        if (culture.convert
            && format !== culture.dateFormats.universal
            && format !== culture.dateTimeFormats.universal)
            converted = culture.convert.fromGregorian(date);
        else
            converted = [date.getFullYear(), date.getMonth(), date.getDate()];
        for (;;) {
            var index = tokenRegExp.lastIndex;
            var ar = tokenRegExp.exec(format);
            var preMatch = format.slice(index, ar ? ar.index : format.length);
            quoteCount += DateExt._appendPreOrPostMatch(preMatch, ret);
            if (!ar)
                break;
            if ((quoteCount % 2) === 1) {
                ret.append(ar[0]);
                continue;
            }
            switch (ar[0]) {
                case "eee":
                case "EEE":
                    ret.append(DateExt._getWeekDay(culture.day.format.abbreviated, date));
                    break;
                case "eeee":
                case "EEEE":
                    ret.append(DateExt._getWeekDay(culture.day.format.wide, date));
                    break;
                case "eeeee":
                case "EEEEE":
                    ret.append(DateExt._getWeekDay(culture.day.format.narrow, date));
                    break;
                case "eeeeee":
                case "EEEEEE":
                    ret.append(DateExt._getWeekDay(culture.day.format.short, date));
                    break;
                case "ccc":
                    ret.append(DateExt._getWeekDay(culture.day.standAlone.abbreviated, date));
                    break;
                case "cccc":
                    ret.append(DateExt._getWeekDay(culture.day.standAlone.wide, date));
                    break;
                case "ccccc":
                    ret.append(DateExt._getWeekDay(culture.day.standAlone.narrow, date));
                    break;
                case "cccccc":
                    ret.append(DateExt._getWeekDay(culture.day.standAlone.short, date));
                    break;
                case "dd":
                    foundDay = true;
                    ret.append(addLeadingZero(converted[DatePart.Day]));
                    break;
                case "d":
                    foundDay = true;
                    ret.append(converted[DatePart.Day].toString());
                    break;
                case "M":
                case "L":
                    ret.append((converted[DatePart.Month] + 1).toString());
                    break;
                case "MM":
                case "LL":
                    ret.append(addLeadingZero(converted[DatePart.Month] + 1));
                    break;
                case "MMM":
                    ret.append(culture.month.format.abbreviated[converted[DatePart.Month]]);
                    break;
                case "MMMM":
                    ret.append(culture.month.format.wide[converted[DatePart.Month]]);
                    break;
                case "MMMMM":
                    ret.append(culture.month.format.narrow[converted[DatePart.Month]]);
                    break;
                case "LLL":
                    ret.append(culture.month.standAlone.abbreviated[converted[DatePart.Month]]);
                    break;
                case "LLLL":
                    ret.append(culture.month.standAlone.wide[converted[DatePart.Month]]);
                    break;
                case "LLLLL":
                    ret.append(culture.month.standAlone.narrow[converted[DatePart.Month]]);
                    break;
                case "yyyy":
                    ret.append(padYear(converted[DatePart.Year]));
                    break;
                case "yy":
                    ret.append(addLeadingZero(converted[DatePart.Year] % 100));
                    break;
                case "y":
                    ret.append(converted[DatePart.Year].toString());
                    break;
                case "hh":
                    hour = date.getHours() % 12;
                    if (hour === 0)
                        hour = 12;
                    ret.append(addLeadingZero(hour));
                    break;
                case "h":
                    hour = date.getHours() % 12;
                    if (hour === 0)
                        hour = 12;
                    ret.append(hour.toString());
                    break;
                case "HH":
                    ret.append(addLeadingZero(date.getHours()));
                    break;
                case "H":
                    ret.append(date.getHours().toString());
                    break;
                case "mm":
                    ret.append(addLeadingZero(date.getMinutes()));
                    break;
                case "m":
                    ret.append(date.getMinutes().toString());
                    break;
                case "ss":
                    ret.append(addLeadingZero(date.getSeconds()));
                    break;
                case "s":
                    ret.append(date.getSeconds().toString());
                    break;
                case "a":
                    ret.append((date.getHours() < 12) ? culture.am : culture.pm);
                    break;
                case "z":
                    hour = date.getTimezoneOffset() / 60;
                    ret.append(((hour <= 0) ? '+' : '-') + Math.floor(Math.abs(hour)));
                    break;
                case "zz":
                    hour = date.getTimezoneOffset() / 60;
                    ret.append(((hour <= 0) ? '+' : '-') + addLeadingZero(Math.floor(Math.abs(hour))));
                    break;
                case "zzz":
                case 'zzzz':
                    hour = date.getTimezoneOffset() / 60;
                    ret.append(((hour <= 0) ? '+' : '-') + addLeadingZero(Math.floor(Math.abs(hour))) +
                        ":" + addLeadingZero(Math.abs(date.getTimezoneOffset() % 60)));
                    break;
                case "G":
                case "GG":
                case "g":
                case "gg":
                    if (DateExt.era) {
                        ret.append(DateExt.era[DateExt._getEra(date, DateExt.era) + 1]);
                    }
                    break;
            }
        }
        return ret.toString();
    };
    return DateExt;
}());
exports.DateExt = DateExt;
var DatePart;
(function (DatePart) {
    DatePart[DatePart["Year"] = 0] = "Year";
    DatePart[DatePart["Month"] = 1] = "Month";
    DatePart[DatePart["Day"] = 2] = "Day";
})(DatePart || (DatePart = {}));
//# sourceMappingURL=date-ext.js.map


//////////////////
// WEBPACK FOOTER
// ../player-globalization/date-ext.js
// module id = 297
// module chunks = 0 1